import { createSelector } from 'reselect'

const stateAppliedFilters = state => state.product.appliedFilters

export const getCategoryNameFromFilter = createSelector([stateAppliedFilters], filters => {
  const categoryFilter = filters.find(e => e.id === 'category')
  if (categoryFilter && categoryFilter.labels) return categoryFilter.labels[0]
})
